/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentConfirmRestRequest
 */
export interface PaymentConfirmRestRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentConfirmRestRequest
     */
    merchantId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentConfirmRestRequest
     */
    posId?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentConfirmRestRequest
     */
    sessionId?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentConfirmRestRequest
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentConfirmRestRequest
     */
    originAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentConfirmRestRequest
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentConfirmRestRequest
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentConfirmRestRequest
     */
    methodId?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentConfirmRestRequest
     */
    statement?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentConfirmRestRequest
     */
    sign?: string;
}

export function PaymentConfirmRestRequestFromJSON(json: any): PaymentConfirmRestRequest {
    return PaymentConfirmRestRequestFromJSONTyped(json, false);
}

export function PaymentConfirmRestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentConfirmRestRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchantId': !exists(json, 'merchantId') ? undefined : json['merchantId'],
        'posId': !exists(json, 'posId') ? undefined : json['posId'],
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'originAmount': !exists(json, 'originAmount') ? undefined : json['originAmount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'methodId': !exists(json, 'methodId') ? undefined : json['methodId'],
        'statement': !exists(json, 'statement') ? undefined : json['statement'],
        'sign': !exists(json, 'sign') ? undefined : json['sign'],
    };
}

export function PaymentConfirmRestRequestToJSON(value?: PaymentConfirmRestRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchantId': value.merchantId,
        'posId': value.posId,
        'sessionId': value.sessionId,
        'amount': value.amount,
        'originAmount': value.originAmount,
        'currency': value.currency,
        'orderId': value.orderId,
        'methodId': value.methodId,
        'statement': value.statement,
        'sign': value.sign,
    };
}


